<template>
  <h1>Mensajes</h1>
</template>

<script>
export default {}
</script>

<style></style>
